<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="m-3">
            <h3>Edit Management</h3>
            <div v-if="pageLoading" class="mt-3">
                Loading...
            </div>
            <EditElement :elementIdProp="pageId" category_id="8"></EditElement>
        </div>
    </div>
</template>

<script>
import EditElement from "@/components/ElementComponents/EditElement";

export default {
    name: 'editManagement',
    components: {
        EditElement,
    },
    data() {
        return {
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'Management',
                    to: '/managements/all'
                }, {
                    text: 'Edit Management',
                    href: '#'
                }
            ],
            pageId: null,
        };
    },
    created() {
        this.pageId = this.$route.params.id;
    },
}
</script>